import React from 'react';
import { motion } from 'framer-motion';
import { Flame, ChevronDown, Sparkles } from 'lucide-react';
export function NewHero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black" data-id="element-1399">
      {/* Enhanced atmospheric background with more depth */}
      <div className="absolute inset-0 bg-gradient-radial from-stone-900 via-black to-black" data-id="element-1400" />

      {/* Larger, more dramatic candlelight glow spots */}
      <div className="absolute top-1/4 left-1/4 w-[600px] h-[600px] bg-amber-600/15 rounded-full blur-3xl animate-flicker" data-id="element-1401" />
      <div className="absolute bottom-1/3 right-1/4 w-[600px] h-[600px] bg-amber-500/15 rounded-full blur-3xl animate-flicker-delayed" data-id="element-1402" />

      {/* Additional ambient glow for depth */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-600/5 rounded-full blur-3xl animate-pulse-slow" data-id="element-1403" />

      {/* Vignette for focus */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 pointer-events-none" data-id="element-1404" />

      {/* MONUMENTAL BACKGROUND LOGO - Your actual PSI logo as powerful presence */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 3,
      delay: 0.5
    }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{
      width: '100vh',
      height: '100vh' // Mobile default
    }} data-id="element-1405">
        {/* Responsive width override */}
        <style data-id="element-1406">{`
        @media (min-width: 768px) {
          .hero-logo-container {
            width: 180vh !important;
            height: 180vh !important;
          }
        }
      `}</style>
        {/* PSI Logo - Rotating slowly with perfect opacity */}
        <motion.div className="w-full h-full flex items-center justify-center hero-logo-container" animate={{
        rotate: [0, 360]
      }} transition={{
        duration: 180,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-1407">
          <img src="https://cdn.magicpatterns.com/uploads/jToXSpcV6pHGAAwW9hQchh/PeptideScienceInstituteLogo2-Transparent.png" alt="PSI Logo" className="w-full h-full object-contain" style={{
          opacity: 0.06,
          filter: 'blur(1px)'
        }} data-id="element-1408" />
        </motion.div>

        {/* Subtle glow effect around the logo */}
        <motion.div className="absolute inset-0 bg-gradient-radial from-purple-600/8 via-cyan-600/5 to-transparent blur-3xl" animate={{
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-1409" />
      </motion.div>

      {/* Enhanced floating candles - more of them with varied timing */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 0.8
    }} className="absolute top-32 left-16 hidden lg:flex flex-col items-center" data-id="element-1410">
        <Flame className="w-7 h-7 text-amber-500 animate-flicker" data-id="element-1411" />
        <div className="w-1 h-20 bg-gradient-to-b from-amber-900/60 to-transparent" data-id="element-1412" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 1.0
    }} className="absolute top-32 right-16 hidden lg:flex flex-col items-center" data-id="element-1413">
        <Flame className="w-7 h-7 text-amber-500 animate-flicker-delayed" data-id="element-1414" />
        <div className="w-1 h-20 bg-gradient-to-b from-amber-900/60 to-transparent" data-id="element-1415" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 0.9
    }} className="absolute top-1/3 left-32 hidden xl:flex flex-col items-center" data-id="element-1416">
        <Flame className="w-6 h-6 text-amber-500 animate-flicker" style={{
        animationDelay: '0.3s'
      }} data-id="element-1417" />
        <div className="w-1 h-16 bg-gradient-to-b from-amber-900/50 to-transparent" data-id="element-1418" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 1.1
    }} className="absolute top-1/3 right-32 hidden xl:flex flex-col items-center" data-id="element-1419">
        <Flame className="w-6 h-6 text-amber-500 animate-flicker-delayed" style={{
        animationDelay: '0.5s'
      }} data-id="element-1420" />
        <div className="w-1 h-16 bg-gradient-to-b from-amber-900/50 to-transparent" data-id="element-1421" />
      </motion.div>

      {/* Enhanced decorative corner ornaments with glow */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 4.3
    }} className="absolute top-4 left-4 sm:top-8 sm:left-8 w-20 h-20 sm:w-32 sm:h-32 border-l-2 border-t-2 border-amber-600/40" style={{
      boxShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
    }} data-id="element-1422">
        <div className="absolute top-2 left-2 w-3 h-3 bg-amber-500 rounded-full animate-pulse" data-id="element-1423" />
      </motion.div>
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 4.3
    }} className="absolute top-4 right-4 sm:top-8 sm:right-8 w-20 h-20 sm:w-32 sm:h-32 border-r-2 border-t-2 border-amber-600/40" style={{
      boxShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
    }} data-id="element-1424">
        <div className="absolute top-2 right-2 w-3 h-3 bg-amber-500 rounded-full animate-pulse" data-id="element-1425" />
      </motion.div>
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 4.3
    }} className="absolute bottom-4 left-4 sm:bottom-8 sm:left-8 w-20 h-20 sm:w-32 sm:h-32 border-l-2 border-b-2 border-amber-600/40" style={{
      boxShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
    }} data-id="element-1426">
        <div className="absolute bottom-2 left-2 w-3 h-3 bg-amber-500 rounded-full animate-pulse" data-id="element-1427" />
      </motion.div>
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 4.3
    }} className="absolute bottom-4 right-4 sm:bottom-8 sm:right-8 w-20 h-20 sm:w-32 sm:h-32 border-r-2 border-b-2 border-amber-600/40" style={{
      boxShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
    }} data-id="element-1428">
        <div className="absolute bottom-2 right-2 w-3 h-3 bg-amber-500 rounded-full animate-pulse" data-id="element-1429" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center py-12 sm:py-16 md:py-20" data-id="element-1430">
        {/* Wax seal icon above pre-headline */}
        <motion.div initial={{
        opacity: 0,
        scale: 0
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        type: 'spring'
      }} className="flex justify-center mb-6" data-id="element-1431">
          <div className="relative" data-id="element-1432">
            <div className="absolute inset-0 bg-amber-500/30 blur-xl rounded-full" data-id="element-1433" />
            <Sparkles className="relative w-10 h-10 text-amber-500" style={{
            filter: 'drop-shadow(0 0 10px rgba(251, 191, 36, 0.8))'
          }} data-id="element-1434" />
          </div>
        </motion.div>

        {/* Pre-headline - Enhanced */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-6 sm:mb-8 md:mb-10" data-id="element-1435">
          <motion.p className="text-sm sm:text-base md:text-lg tracking-[0.2em] sm:tracking-[0.3em] uppercase font-light" animate={{
          textShadow: ['0 0 20px rgba(217, 119, 6, 0.4)', '0 0 30px rgba(217, 119, 6, 0.6)', '0 0 20px rgba(217, 119, 6, 0.4)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          color: '#f59e0b'
        }} data-id="element-1436">
            Join Peptide Science Institute's 2026
          </motion.p>
        </motion.div>

        {/* Main headline - DRAMATICALLY ENHANCED with split lines */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 1.0
      }} className="mb-8 sm:mb-10" data-id="element-1437">
          <motion.h1 initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 1.2,
          type: 'spring',
          stiffness: 100
        }} className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold leading-tight" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1438">
            <motion.span className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400 bg-clip-text text-transparent" style={{
            backgroundSize: '200% 100%',
            textShadow: '0 0 100px rgba(217, 119, 6, 1), 0 0 60px rgba(217, 119, 6, 0.8)',
            filter: 'drop-shadow(0 0 40px rgba(251, 191, 36, 0.6))'
          }} animate={{
            backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-1439">
              PRIVATE RESEARCH
            </motion.span>
          </motion.h1>

          <motion.h1 initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 1.4,
          type: 'spring',
          stiffness: 100
        }} className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1440">
            <motion.span className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400 bg-clip-text text-transparent" style={{
            backgroundSize: '200% 100%',
            textShadow: '0 0 100px rgba(217, 119, 6, 1), 0 0 60px rgba(217, 119, 6, 0.8)',
            filter: 'drop-shadow(0 0 40px rgba(251, 191, 36, 0.6))'
          }} animate={{
            backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-1441">
              ORDER
            </motion.span>
          </motion.h1>
        </motion.div>

        {/* Sub-headline - Enhanced with PRECISION theme and molecular visuals */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.8
      }} className="mb-8 sm:mb-12 relative" data-id="element-1442">
          {/* Molecular structure background - subtle precision visual */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-10" data-id="element-1443">
            <svg width="400" height="200" viewBox="0 0 400 200" className="text-cyan-400" data-id="element-1444">
              {/* Hexagonal molecular structure */}
              <g transform="translate(200, 100)" data-id="element-1445">
                {/* Central hexagon */}
                <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-1446" />
                <circle cx="0" cy="-30" r="4" fill="currentColor" data-id="element-1447" />
                <circle cx="26" cy="-15" r="4" fill="currentColor" data-id="element-1448" />
                <circle cx="26" cy="15" r="4" fill="currentColor" data-id="element-1449" />
                <circle cx="0" cy="30" r="4" fill="currentColor" data-id="element-1450" />
                <circle cx="-26" cy="15" r="4" fill="currentColor" data-id="element-1451" />
                <circle cx="-26" cy="-15" r="4" fill="currentColor" data-id="element-1452" />

                {/* Connected molecules */}
                <line x1="0" y1="-30" x2="0" y2="-60" stroke="currentColor" strokeWidth="1" data-id="element-1453" />
                <circle cx="0" cy="-60" r="3" fill="currentColor" data-id="element-1454" />

                <line x1="26" y1="15" x2="56" y2="30" stroke="currentColor" strokeWidth="1" data-id="element-1455" />
                <circle cx="56" cy="30" r="3" fill="currentColor" data-id="element-1456" />

                <line x1="-26" y1="15" x2="-56" y2="30" stroke="currentColor" strokeWidth="1" data-id="element-1457" />
                <circle cx="-56" cy="30" r="3" fill="currentColor" data-id="element-1458" />
              </g>
            </svg>
          </div>

          {/* Precision measurement lines - left side */}
          <motion.div className="absolute left-0 top-1/2 -translate-y-1/2 hidden lg:block" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 2.2
        }} data-id="element-1459">
            <div className="flex items-center gap-2" data-id="element-1460">
              <div className="w-12 h-px bg-gradient-to-r from-transparent to-cyan-500/50" data-id="element-1461" />
              <div className="w-1 h-1 bg-cyan-500 rounded-full" data-id="element-1462" />
              <div className="w-1 h-20 bg-gradient-to-b from-cyan-500/50 to-transparent" data-id="element-1463" />
            </div>
          </motion.div>

          {/* Precision measurement lines - right side */}
          <motion.div className="absolute right-0 top-1/2 -translate-y-1/2 hidden lg:block" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 2.2
        }} data-id="element-1464">
            <div className="flex items-center gap-2 flex-row-reverse" data-id="element-1465">
              <div className="w-12 h-px bg-gradient-to-l from-transparent to-cyan-500/50" data-id="element-1466" />
              <div className="w-1 h-1 bg-cyan-500 rounded-full" data-id="element-1467" />
              <div className="w-1 h-20 bg-gradient-to-b from-cyan-500/50 to-transparent" data-id="element-1468" />
            </div>
          </motion.div>

          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-serif leading-tight text-stone-100 mb-2" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1469">
            The Elite Scientific Membership
          </p>

          <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-serif leading-tight text-stone-100 mt-2 sm:mt-3" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1470">
            for Healing, Enhancing & Controlling Biology
          </p>

          {/* PRECISION emphasis with targeting reticle visual */}
          <motion.div className="mt-4 sm:mt-6 relative inline-block" initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 2.4
        }} data-id="element-1471">
            {/* Precision targeting reticle background */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-1472">
              <motion.svg width="280" height="80" viewBox="0 0 280 80" className="text-cyan-500/20" animate={{
              rotate: [0, 360]
            }} transition={{
              duration: 60,
              repeat: Infinity,
              ease: 'linear'
            }} data-id="element-1473">
                {/* Crosshair circles */}
                <circle cx="140" cy="40" r="35" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1474" />
                <circle cx="140" cy="40" r="25" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-1475" />

                {/* Crosshair lines */}
                <line x1="140" y1="5" x2="140" y2="20" stroke="currentColor" strokeWidth="1" data-id="element-1476" />
                <line x1="140" y1="60" x2="140" y2="75" stroke="currentColor" strokeWidth="1" data-id="element-1477" />
                <line x1="105" y1="40" x2="120" y2="40" stroke="currentColor" strokeWidth="1" data-id="element-1478" />
                <line x1="160" y1="40" x2="175" y2="40" stroke="currentColor" strokeWidth="1" data-id="element-1479" />

                {/* Corner markers */}
                <path d="M 110 15 L 110 10 L 115 10" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1480" />
                <path d="M 170 15 L 170 10 L 165 10" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1481" />
                <path d="M 110 65 L 110 70 L 115 70" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1482" />
                <path d="M 170 65 L 170 70 L 165 70" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1483" />
              </motion.svg>
            </div>

            <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-serif font-bold leading-tight relative z-10" style={{
            fontFamily: 'Cinzel, serif'
          }} data-id="element-1484">
              <span className="relative inline-block" data-id="element-1485">
                <span className="text-cyan-300" style={{
                textShadow: '0 0 30px rgba(103, 232, 249, 0.6), 0 0 60px rgba(103, 232, 249, 0.3)'
              }} data-id="element-1486">
                  Beyond Mainstream Limitations
                </span>

                {/* Precision measurement indicators */}
                <motion.div className="absolute -left-8 top-1/2 -translate-y-1/2 hidden md:block" animate={{
                x: [-2, 2, -2]
              }} transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-1487">
                  <div className="flex items-center gap-1" data-id="element-1488">
                    <div className="w-1 h-8 bg-gradient-to-b from-transparent via-cyan-400 to-transparent" data-id="element-1489" />
                    <div className="w-1 h-1 bg-cyan-400 rounded-full" data-id="element-1490" />
                  </div>
                </motion.div>

                <motion.div className="absolute -right-8 top-1/2 -translate-y-1/2 hidden md:block" animate={{
                x: [2, -2, 2]
              }} transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-1491">
                  <div className="flex items-center gap-1 flex-row-reverse" data-id="element-1492">
                    <div className="w-1 h-8 bg-gradient-to-b from-transparent via-cyan-400 to-transparent" data-id="element-1493" />
                    <div className="w-1 h-1 bg-cyan-400 rounded-full" data-id="element-1494" />
                  </div>
                </motion.div>

                {/* Underline with measurement ticks */}
                <span className="absolute -bottom-2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent" data-id="element-1495" />

                {/* Measurement tick marks */}
                <span className="absolute -bottom-3 left-1/4 w-px h-2 bg-cyan-400/60" data-id="element-1496" />
                <span className="absolute -bottom-3 left-1/2 w-px h-3 bg-cyan-400" data-id="element-1497" />
                <span className="absolute -bottom-3 left-3/4 w-px h-2 bg-cyan-400/60" data-id="element-1498" />
              </span>
            </p>

            {/* Floating precision particles */}
            <div className="absolute inset-0 pointer-events-none" data-id="element-1499">
              {[...Array(4)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-cyan-400 rounded-full" style={{
              left: `${25 + i * 20}%`,
              top: i % 2 === 0 ? '-10px' : '110%'
            }} animate={{
              y: i % 2 === 0 ? [0, 10, 0] : [0, -10, 0],
              opacity: [0.3, 1, 0.3]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.3,
              ease: 'easeInOut'
            }} data-id="element-1500" />)}
            </div>
          </motion.div>
        </motion.div>

        {/* DNA Helix Divider - Scientific but mystical */}
        <motion.div initial={{
        opacity: 0,
        scale: 0
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 2.2
      }} className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-1501">
          <motion.div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-600 to-amber-600" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1502" />
          <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-1503">
            <svg width="24" height="24" viewBox="0 0 24 24" className="text-amber-500" data-id="element-1504">
              <circle cx="12" cy="6" r="2" fill="currentColor" opacity="0.8" data-id="element-1505" />
              <circle cx="12" cy="12" r="2" fill="currentColor" data-id="element-1506" />
              <circle cx="12" cy="18" r="2" fill="currentColor" opacity="0.8" data-id="element-1507" />
              <path d="M12 6 L12 18" stroke="currentColor" strokeWidth="1" opacity="0.4" data-id="element-1508" />
            </svg>
          </motion.div>
          <motion.div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-600 to-amber-600" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1509" />
        </motion.div>

        {/* Target audience - Enhanced with better breaks and emphasis */}
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 2.6
      }} className="text-lg sm:text-xl md:text-2xl text-stone-300 mb-10 sm:mb-16 leading-relaxed max-w-5xl mx-auto" data-id="element-1510">
          If you're a doctor, clinician, coach, practitioner,
          <br data-id="element-1511" />
          or an advanced biohacker ready to gain{' '}
          <span className="font-bold text-amber-400 px-2 py-1 border border-amber-500/30 bg-amber-950/30 rounded" style={{
          textShadow: '0 0 20px rgba(251, 191, 36, 0.4)'
        }} data-id="element-1512">
            REAL control
          </span>{' '}
          of human biology
          <br data-id="element-1513" />
          (for yourself or for others)...
        </motion.p>

        {/* DRAMATIC PAUSE - then the hook (NO BOX, NO BREATHING) */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 3.5,
        type: 'spring',
        stiffness: 80
      }} className="mb-8 sm:mb-12 relative" data-id="element-1514">
          {/* Dramatic spotlight effect behind text */}
          <motion.div className="absolute inset-0 -inset-x-20 bg-gradient-radial from-amber-600/20 via-amber-600/5 to-transparent blur-3xl" animate={{
          opacity: [0.3, 0.6, 0.3],
          scale: [1, 1.1, 1]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1515" />

          {/* Subtle particle effects around the text */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-1516">
            {[...Array(6)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-amber-400 rounded-full" style={{
            left: `${20 + i * 15}%`,
            top: '50%'
          }} animate={{
            y: [-20, -40, -20],
            opacity: [0, 1, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            delay: i * 0.5,
            ease: 'easeInOut'
          }} data-id="element-1517" />)}
          </div>

          <div className="relative text-center max-w-4xl mx-auto space-y-2 sm:space-y-4" data-id="element-1518">
            <motion.p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold" style={{
            background: 'linear-gradient(to right, #fbbf24, #f59e0b, #fbbf24)',
            backgroundSize: '200% 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 0 40px rgba(251, 191, 36, 0.4))'
          }} animate={{
            backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-1519">
              This could be the
            </motion.p>

            <motion.p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-amber-400" style={{
            textShadow: '0 0 60px rgba(251, 191, 36, 0.6)'
          }} data-id="element-1520">
              most life-changing opportunity
              <br data-id="element-1521" />
              you ever get
            </motion.p>
          </div>

          {/* Subtle underline accent */}
          <motion.div className="mx-auto mt-6 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent" style={{
          width: '60%'
        }} initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 1,
          delay: 4,
          ease: 'easeOut'
        }} data-id="element-1522" />
        </motion.div>

        {/* TESTIMONIALS SECTION - Supporting Claims */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 4.2
      }} className="mt-12 sm:mt-20 mb-10 sm:mb-16 max-w-4xl mx-auto" data-id="element-1523">
          {/* Section intro - Purple accent */}
          <div className="text-center mb-10 sm:mb-16" data-id="element-1524">
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 4.4
          }} className="text-purple-400 text-lg sm:text-xl font-semibold mb-3" style={{
            textShadow: '0 0 20px rgba(192, 132, 252, 0.3)'
          }} data-id="element-1525">
              Like Our Clients Say
            </motion.p>
            <motion.div className="w-32 h-1 bg-gradient-to-r from-transparent via-purple-500 to-transparent mx-auto" initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: 0.8,
            delay: 4.6
          }} data-id="element-1526" />
          </div>

          {/* Testimonials - Single Column, Stacked */}
          <div className="space-y-10 sm:space-y-16" data-id="element-1527">
            {/* Testimonial 1 - Sean L. */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 4.7
          }} className="relative" data-id="element-1528">
              {/* Subtle background glow - purple tint */}
              <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1529" />

              <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-1530">
                {/* Profile Image */}
                <div className="flex justify-center mb-6" data-id="element-1531">
                  <div className="relative" data-id="element-1532">
                    <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1533" />
                    <img src="https://cdn.magicpatterns.com/uploads/8TaJVJxgg4BMR3q5DqSNsr/SeanL.jpg" alt="Sean L." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1534" />
                  </div>
                </div>

                {/* Large opening quote - purple */}
                <div className="mb-4 sm:mb-6" data-id="element-1535">
                  <span className="text-purple-500/40 text-5xl sm:text-7xl font-serif leading-none" data-id="element-1536">
                    "
                  </span>
                </div>

                {/* TV Screen Frame around testimonial text */}
                <div className="relative mb-6 sm:mb-8 max-w-3xl" data-id="element-1537">
                  {/* Outer purple glow */}
                  <div className="absolute -inset-4 bg-purple-500/10 blur-xl rounded-lg" data-id="element-1538" />

                  {/* TV screen frame */}
                  <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1539">
                    {/* Screen scanline effect (subtle) */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1540" />

                    {/* Testimonial text - with emphasis on key phrases */}
                    <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1541">
                      They're doing something{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1542">
                        revolutionary
                      </span>{' '}
                      here. You'll be getting something extremely personalized,
                      you'll be getting the care that you need, you'll be
                      getting the support you need, the multi-faceted support
                      you need, should you decide to work with the Peptide
                      Science Institute, both on the emotional front, mental
                      front, and on the medical front. Working with them is just
                      a fantastic experience and I highly recommend this to
                      anybody who's even considering, if you're looking for
                      something{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1543">
                        life-changing
                      </span>
                      , if you want to{' '}
                      <span className="text-white font-bold" data-id="element-1544">
                        attack diseases that the mainstream says is not really
                        something treatable
                      </span>
                      ...{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1545">
                        it will blow your mind.
                      </span>{' '}
                      That's what I can guarantee.
                    </p>
                  </div>
                </div>

                {/* Attribution with client type */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1546">
                  <div className="h-px w-full sm:w-auto sm:flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1547" />
                  <div className="text-center sm:text-right" data-id="element-1548">
                    <p className="text-purple-400 font-semibold text-base sm:text-lg mb-1" data-id="element-1549">
                      Sean L.
                    </p>
                    <p className="text-stone-500 text-sm" data-id="element-1550">
                      Transformation Services Client
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Testimonial 2 - Wilfred A. */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 4.9
          }} className="relative" data-id="element-1551">
              {/* Subtle background glow - purple tint */}
              <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1552" />

              <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-1553">
                {/* Profile Image */}
                <div className="flex justify-center mb-6" data-id="element-1554">
                  <div className="relative" data-id="element-1555">
                    <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1556" />
                    <img src="https://cdn.magicpatterns.com/uploads/3sr1cDaEEULSv8K4Ew3yfQ/WilfredA.jpg" alt="Wilfred A." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1557" />
                  </div>
                </div>

                {/* Large opening quote - purple */}
                <div className="mb-4 sm:mb-6" data-id="element-1558">
                  <span className="text-purple-500/40 text-5xl sm:text-7xl font-serif leading-none" data-id="element-1559">
                    "
                  </span>
                </div>

                {/* TV Screen Frame around testimonial text */}
                <div className="relative mb-6 sm:mb-8 max-w-3xl" data-id="element-1560">
                  {/* Outer purple glow */}
                  <div className="absolute -inset-4 bg-purple-500/10 blur-xl rounded-lg" data-id="element-1561" />

                  {/* TV screen frame */}
                  <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1562">
                    {/* Screen scanline effect (subtle) */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1563" />

                    {/* Testimonial text - with emphasis on key phrases */}
                    <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1564">
                      I{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1565">
                        100% would put my name behind
                      </span>{' '}
                      Ali & Brenden. I've had other health coaches in the past
                      (most are MD's), and I must say, Brenden & Ali are{' '}
                      <span className="text-white font-bold" data-id="element-1566">
                        FAR more in depth, systems-oriented, and rigorous
                      </span>{' '}
                      than anything I've ever seen. Also I did grab that
                      peptides course. It has given me the knowledge to turn
                      familys' health conditions around even when the medical
                      system has failed them. I owe this to the lessons I've
                      acquired from Ali & Brenden. In terms of level of positive
                      impact on my life, they are likely in the{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1567">
                        top 5 most important people I've ever met
                      </span>{' '}
                      as they have{' '}
                      <span className="text-white font-bold" data-id="element-1568">
                        added many years to my life
                      </span>{' '}
                      and to those of my loved ones.
                    </p>
                  </div>
                </div>

                {/* Attribution with client type */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1569">
                  <div className="h-px w-full sm:w-auto sm:flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1570" />
                  <div className="text-center sm:text-right" data-id="element-1571">
                    <p className="text-purple-400 font-semibold text-base sm:text-lg mb-1" data-id="element-1572">
                      Wilfred A.
                    </p>
                    <p className="text-stone-500 text-sm" data-id="element-1573">
                      Peptide Mastery Owner & Transformation Services Client
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Testimonial 3 - Ronald R. */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 5.1
          }} className="relative" data-id="element-1574">
              {/* Subtle background glow - purple tint */}
              <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1575" />

              <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-1576">
                {/* Large opening quote - purple */}
                <div className="mb-4 sm:mb-6" data-id="element-1577">
                  <span className="text-purple-500/40 text-5xl sm:text-7xl font-serif leading-none" data-id="element-1578">
                    "
                  </span>
                </div>

                {/* TV Screen Frame around testimonial text */}
                <div className="relative mb-6 sm:mb-8 max-w-3xl" data-id="element-1579">
                  {/* Outer purple glow */}
                  <div className="absolute -inset-4 bg-purple-500/10 blur-xl rounded-lg" data-id="element-1580" />

                  {/* TV screen frame */}
                  <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1581">
                    {/* Screen scanline effect (subtle) */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1582" />

                    {/* Testimonial text - with emphasis on key phrases */}
                    <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1583">
                      I am a{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1584">
                        physician with an integrative medicine practice
                      </span>{' '}
                      and your work has been{' '}
                      <span className="text-white font-bold" data-id="element-1585">
                        very valuable in treating my patients.
                      </span>{' '}
                      When I lecture to physicians I always mention "peptide
                      mastery" as a great source of material and{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-1586">
                        extensive references
                      </span>
                      ... It has been very helpful in my care of patients and I
                      appreciate the extensive references.
                    </p>
                  </div>
                </div>

                {/* Attribution with client type */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1587">
                  <div className="h-px w-full sm:w-auto sm:flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1588" />
                  <div className="text-center sm:text-right" data-id="element-1589">
                    <p className="text-purple-400 font-semibold text-base sm:text-lg mb-1" data-id="element-1590">
                      Ronald R.
                    </p>
                    <p className="text-stone-500 text-sm" data-id="element-1591">
                      Peptide Mastery Owner
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* MASSIVE BREATHING ROOM - Let the claim sink in */}

        {/* For The Ones Who Already Know - COMPLETELY REDESIGNED OFFER BOX */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 4.3
      }} className="mb-8 sm:mb-12 relative" data-id="element-1592">
          {/* Distinctive outer glow to separate from page */}
          <div className="absolute -inset-4 bg-gradient-to-r from-amber-600/20 via-purple-600/20 to-cyan-600/20 blur-2xl rounded-lg" data-id="element-1593" />

          {/* Main offer box with SIMPLE BLACK background */}
          <div className="relative p-6 sm:p-10 md:p-12 bg-black border-4 border-amber-500/60 rounded-lg shadow-[0_0_80px_rgba(217,119,6,0.4)]" data-id="element-1594">
            {/* Decorative top accent */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1595"></div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 4.3
          }} className="text-center mb-6 sm:mb-8" data-id="element-1596">
              <div className="inline-block px-4 sm:px-8 py-2 sm:py-3 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 border-2 border-amber-500/60 rounded-lg" data-id="element-1597">
                <p className="text-amber-300 text-lg sm:text-xl md:text-2xl font-bold tracking-wide" style={{
                textShadow: '0 0 20px rgba(252, 211, 77, 0.5)'
              }} data-id="element-1598">
                  SPECIAL FOUNDING MEMBER'S OFFER - For Guidance Throughout 2026
                </p>
              </div>
            </motion.div>

            {/* Celebratory Trophy Animation - Moved below offer box */}

            {/* Updated headline */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 4.5
          }} className="mt-4 sm:mt-6 mb-8 sm:mb-10" data-id="element-1599">
              <p className="text-amber-400 text-xl sm:text-2xl md:text-3xl font-bold text-center leading-relaxed" data-id="element-1600">
                For Those Who Already Know the Quality & Value We Provide
                <br data-id="element-1601" />
              </p>
            </motion.div>

            {/* Divider */}
            <div className="flex items-center justify-center gap-4 my-8 sm:my-10" data-id="element-1602">
              <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-1603" />
              <div className="w-3 h-3 bg-amber-500 rotate-45" data-id="element-1604" />
              <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-1605" />
            </div>

            {/* WHO THIS IS FOR Section */}
            <div className="mb-8 sm:mb-10" data-id="element-1606">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 5.2
            }} className="text-center mb-6 sm:mb-8" data-id="element-1607">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4" style={{
                textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
              }} data-id="element-1608">
                  👥 WHO THIS IS FOR
                </h3>
                <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-1609" />
              </motion.div>

              <div className="space-y-6 max-w-3xl mx-auto text-stone-300 mb-8 sm:mb-10" data-id="element-1610">
                <p className="text-base sm:text-lg text-center" data-id="element-1611">Two groups:</p>

                <div className="space-y-4 sm:space-y-6" data-id="element-1612">
                  <div className="p-4 sm:p-6 bg-cyan-950/20 border-l-4 border-cyan-500 rounded-r-lg" data-id="element-1613">
                    <p className="font-bold text-lg sm:text-xl text-cyan-300 mb-2 sm:mb-3" data-id="element-1614">
                      1) Intelligent Biohackers
                    </p>
                    <p className="text-stone-300 text-sm sm:text-base" data-id="element-1615">
                      Who want total mastery over their own biology (and to help
                      their family's health).
                    </p>
                  </div>

                  <div className="p-4 sm:p-6 bg-emerald-950/20 border-l-4 border-emerald-500 rounded-r-lg" data-id="element-1616">
                    <p className="font-bold text-lg sm:text-xl text-emerald-300 mb-2 sm:mb-3" data-id="element-1617">
                      2) Clinicians/Coaches/Practitioners
                    </p>
                    <p className="text-stone-300 text-sm sm:text-base" data-id="element-1618">
                      Who want to be the "go-to" expert who can help almost
                      anyone, when everyone else has failed.
                    </p>
                  </div>
                </div>

                <div className="text-center space-y-3 sm:space-y-4 py-4 sm:py-6" data-id="element-1619">
                  <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1620">
                    We're looking for leaders who can lead themselves AND lead
                    others.
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-1621">
                    People who are proactive, committed and take FULL
                    responsibility.
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-1622">
                    People who want to execute with certainty in a world full of
                    noise.
                  </p>
                  <p className="text-xl sm:text-2xl font-bold text-amber-400 mt-4 sm:mt-6" style={{
                  textShadow: '0 0 20px rgba(251, 191, 36, 0.4)'
                }} data-id="element-1623">
                    This is the opportunity you've been waiting for.
                  </p>
                </div>
              </div>
            </div>

            {/* Divider - Added below "This is the opportunity you've been waiting for." */}
            <div className="flex items-center justify-center gap-4 my-8 sm:my-10" data-id="element-1624">
              <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-1625" />
              <div className="w-3 h-3 bg-amber-500 rotate-45" data-id="element-1626" />
              <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-1627" />
            </div>

            {/* WHAT THIS IS Section */}
            <div className="mb-8 sm:mb-10" data-id="element-1628">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 5.15
            }} className="text-center mb-6 sm:mb-8" data-id="element-1629">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4 flex items-center justify-center gap-3" style={{
                textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
              }} data-id="element-1630">
                  <span className="text-3xl sm:text-4xl" data-id="element-1631">🧬</span> WHAT THIS IS
                </h3>
                <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-1632" />
              </motion.div>

              <div className="space-y-6 max-w-3xl mx-auto text-stone-300" data-id="element-1633">
                <p className="text-base sm:text-lg text-center" data-id="element-1634">
                  Right now, new for 2026: The Peptide Science Institute is
                  opening an{' '}
                  <span className="text-purple-400 font-bold" data-id="element-1635">
                    elite, exclusive underground intelligence initiative.
                  </span>
                </p>

                <div className="p-4 sm:p-6 bg-purple-950/20 border-l-4 border-purple-500 rounded-r-lg" data-id="element-1636">
                  <p className="text-lg sm:text-xl font-bold text-purple-300 mb-2 sm:mb-3 text-center" data-id="element-1637">
                    It's called the Private Research Order (PRO).
                  </p>
                  <p className="text-stone-300 text-center text-sm sm:text-base" data-id="element-1638">
                    And we're looking for the best people to join us as founding
                    members.
                  </p>
                </div>

                <div className="text-center space-y-3 sm:space-y-4 py-4 sm:py-6" data-id="element-1639">
                  <p className="text-lg sm:text-xl" data-id="element-1640">
                    <span className="text-amber-400 font-bold" data-id="element-1641">
                      Our mission:
                    </span>{' '}
                    To empower members with the awe-inspiring ability to{' '}
                    <span className="font-bold text-white" data-id="element-1642">
                      control human biology at the cellular level.
                    </span>
                  </p>
                  <p className="text-base sm:text-lg italic text-stone-400" data-id="element-1643">
                    Whether you want to heal, enhance performance, or optimize
                    at the highest levels.
                  </p>
                </div>

                <p className="text-xl sm:text-2xl font-bold text-white text-center" data-id="element-1644">
                  This is a complete intelligence immersion.
                </p>

                <p className="text-base sm:text-lg text-center" data-id="element-1645">
                  You get direct, ongoing access to the two masterminds who
                  decoded the peptide and biological matrix:
                </p>

                {/* Expert Cards - Side by Side */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6 sm:mt-8" data-id="element-1646">
                  {/* Brenden Henry Card */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  duration: 0.5,
                  delay: 5.3
                }} className="p-4 sm:p-6 bg-gradient-to-br from-cyan-950/20 to-black border-2 border-cyan-500/60 rounded-lg" data-id="element-1647">
                    <div className="flex justify-center mb-4" data-id="element-1648">
                      <div className="w-12 h-12 bg-cyan-500 rounded-full flex items-center justify-center" data-id="element-1649">
                        <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 20 20" data-id="element-1650">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1651" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="text-2xl font-bold text-cyan-300 mb-2 text-center" data-id="element-1652">
                      Brenden Henry
                    </h4>
                    <p className="text-cyan-200 font-semibold text-center mb-4" data-id="element-1653">
                      WORLD'S #1 PEPTIDE AUTHORITY
                    </p>
                    <ul className="space-y-2 text-sm text-stone-300" data-id="element-1654">
                      <li className="flex items-start gap-2" data-id="element-1655">
                        <span className="text-cyan-400 mt-1" data-id="element-1656">•</span>
                        <span data-id="element-1657">
                          <span className="font-bold text-cyan-300" data-id="element-1658">
                            First & ONLY person
                          </span>{' '}
                          to translate every original Russian peptide experiment
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1659">
                        <span className="text-cyan-400 mt-1" data-id="element-1660">•</span>
                        <span data-id="element-1661">
                          Creator of{' '}
                          <span className="font-semibold text-cyan-300" data-id="element-1662">
                            Peptide Mastery 2.0
                          </span>{' '}
                          - the most advanced peptide education in history
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1663">
                        <span className="text-cyan-400 mt-1" data-id="element-1664">•</span>
                        <span data-id="element-1665">
                          Primary author of{' '}
                          <span className="italic text-cyan-300" data-id="element-1666">
                            Peptide Salvation
                          </span>{' '}
                          - the world's biggest book on peptides
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1667">
                        <span className="text-cyan-400 mt-1" data-id="element-1668">•</span>
                        <span data-id="element-1669">
                          Originator of the{' '}
                          <span className="font-semibold text-cyan-300" data-id="element-1670">
                            Henry Cofactor Principle
                          </span>
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1671">
                        <span className="text-cyan-400 mt-1" data-id="element-1672">•</span>
                        <span data-id="element-1673">
                          Identified the class of "super peptides" known as{' '}
                          <span className="font-semibold text-cyan-300" data-id="element-1674">
                            bioaugmentors
                          </span>
                        </span>
                      </li>
                    </ul>
                    <p className="text-cyan-300 font-bold text-center mt-4" data-id="element-1675">
                      No one else comes close.
                    </p>
                  </motion.div>

                  {/* Dr. Ali Mazloum Card */}
                  <motion.div initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  duration: 0.5,
                  delay: 5.4
                }} className="p-4 sm:p-6 bg-gradient-to-br from-emerald-950/20 to-black border-2 border-emerald-500/60 rounded-lg" data-id="element-1676">
                    <div className="flex justify-center mb-4" data-id="element-1677">
                      <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center" data-id="element-1678">
                        <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 20 20" data-id="element-1679">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-1680" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="text-2xl font-bold text-emerald-300 mb-2 text-center" data-id="element-1681">
                      Dr. Ali Mazloum
                    </h4>
                    <p className="text-emerald-200 font-semibold text-center mb-4" data-id="element-1682">
                      "THE HUMAN MRI"
                    </p>
                    <ul className="space-y-2 text-sm text-stone-300" data-id="element-1683">
                      <li className="flex items-start gap-2" data-id="element-1684">
                        <span className="text-emerald-400 mt-1" data-id="element-1685">•</span>
                        <span data-id="element-1686">
                          <span className="font-bold text-emerald-300" data-id="element-1687">
                            Diagnostic genius
                          </span>{' '}
                          who spots what entire medical teams miss
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1688">
                        <span className="text-emerald-400 mt-1" data-id="element-1689">•</span>
                        <span data-id="element-1690">
                          Creates{' '}
                          <span className="font-semibold text-emerald-300" data-id="element-1691">
                            "impossible" transformations
                          </span>{' '}
                          that make specialists ask "how?"
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1692">
                        <span className="text-emerald-400 mt-1" data-id="element-1693">•</span>
                        <span data-id="element-1694">
                          Often idolized by other medical specialists at his
                          hospital
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1695">
                        <span className="text-emerald-400 mt-1" data-id="element-1696">•</span>
                        <span data-id="element-1697">
                          Head Transformation Specialist at the{' '}
                          <span className="font-semibold text-emerald-300" data-id="element-1698">
                            Peptide Science Institute
                          </span>
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1699">
                        <span className="text-emerald-400 mt-1" data-id="element-1700">•</span>
                        <span data-id="element-1701">
                          Complete{' '}
                          <span className="font-semibold text-emerald-300" data-id="element-1702">
                            "full stack"
                          </span>{' '}
                          master of the human body
                        </span>
                      </li>
                    </ul>
                    <p className="text-emerald-300 font-bold text-center mt-4" data-id="element-1703">
                      Any opportunity to learn from him is one you should take.
                    </p>
                  </motion.div>
                </div>

                <div className="text-center space-y-3 sm:space-y-4 py-4 sm:py-6 mt-6 sm:mt-8" data-id="element-1704">
                  <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1705">
                    So, at this point you should realize...
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-1706">
                    This isn't some random online course with videos for you to
                    forget about.
                  </p>
                  <p className="text-xl sm:text-2xl font-bold text-amber-400" style={{
                  textShadow: '0 0 20px rgba(251, 191, 36, 0.4)'
                }} data-id="element-1707">
                    This is an invitation to completely upgrade your life.
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-1708">
                    With an elite, continual intelligence feed throughout 2026.
                  </p>
                  <p className="text-lg sm:text-xl font-bold text-white" data-id="element-1709">
                    A living, breathing command center.
                  </p>
                </div>
              </div>
            </div>

            {/* Divider before Where you get */}
            <div className="flex items-center justify-center gap-4 my-8 sm:my-10" data-id="element-1710">
              <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-1711" />
              <div className="w-3 h-3 bg-amber-500 rotate-45" data-id="element-1712" />
              <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-1713" />
            </div>

            {/* WHERE YOU GET Section - Redesigned for visual flow */}
            <div className="mb-8 sm:mb-10" data-id="element-1714">
              <div className="text-center mb-6 sm:mb-8" data-id="element-1715">
                <p className="text-xl sm:text-2xl font-bold text-amber-400 mb-4" data-id="element-1716">
                  Where you get:
                </p>
                <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-1717" />
              </div>

              <div className="grid gap-4 sm:gap-6 max-w-4xl mx-auto" data-id="element-1718">
                {/* Benefit 1 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.3
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-cyan-950/20 to-transparent border-l-4 border-cyan-500 rounded-r-lg" data-id="element-1719">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-cyan-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-1720">
                    1
                  </div>
                  <div data-id="element-1721">
                    <p className="font-bold text-base sm:text-lg text-cyan-300 mb-1 sm:mb-2" data-id="element-1722">
                      Direct, live access to Brenden Henry & Dr. Ali Mazloum
                      each month
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1723">
                      The two people who literally wrote the book on peptides.
                      And who've reversed "irreversible" conditions more times
                      than I can count.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 2 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.4
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-purple-950/20 to-transparent border-l-4 border-purple-500 rounded-r-lg" data-id="element-1724">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-purple-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-1725">
                    2
                  </div>
                  <div data-id="element-1726">
                    <p className="font-bold text-base sm:text-lg text-purple-300 mb-1 sm:mb-2" data-id="element-1727">
                      The Precision Cell™ Pro methodology
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1728">
                      You'll get to learn the core transformation framework
                      Brenden, Ali and our team use to get incredible results
                      for our private clients – ones paying $15,000 to $120,000.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 3 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.5
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-amber-950/20 to-transparent border-l-4 border-amber-500 rounded-r-lg" data-id="element-1729">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-amber-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-1730">
                    3
                  </div>
                  <div data-id="element-1731">
                    <p className="font-bold text-base sm:text-lg text-amber-300 mb-1 sm:mb-2" data-id="element-1732">
                      The complete Peptide Mastery 2.0 program
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1733">
                      130+ peptides. 54 of the most advanced multi-peptide
                      protocols ever created. 1,193 scientific citations. The
                      highest level and most complete peptide education in the
                      world. This alone deserves an hour-long video explaining
                      how powerful the information is. It is genuinely a
                      masterwork. It normally costs $2,500 on its own.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 4 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.6
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/20 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-1734">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-emerald-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-1735">
                    4
                  </div>
                  <div className="text-center flex-1" data-id="element-1736">
                    <p className="font-bold text-base sm:text-lg text-emerald-300 mb-1 sm:mb-2" data-id="element-1737">
                      Dr. Ali Mazloum's Strategic Briefings (LIVE)
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1738">
                      Hidden research. Field reports. Studies you won't find
                      anywhere else.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 5 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.7
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-rose-950/20 to-transparent border-l-4 border-rose-500 rounded-r-lg" data-id="element-1739">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-rose-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-1740">
                    5
                  </div>
                  <div className="text-center flex-1" data-id="element-1741">
                    <p className="font-bold text-base sm:text-lg text-rose-300 mb-1 sm:mb-2" data-id="element-1742">
                      Brenden Henry's Monthly Intelligence Drops
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1743">
                      New research drops. Protocol updates. Real-time
                      intelligence on what's working NOW.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 6 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.8
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-blue-950/20 to-transparent border-l-4 border-blue-500 rounded-r-lg" data-id="element-1744">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-blue-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-1745">
                    6
                  </div>
                  <div className="text-center flex-1" data-id="element-1746">
                    <p className="font-bold text-base sm:text-lg text-blue-300 mb-1 sm:mb-2" data-id="element-1747">
                      Questions & Answers Direct From the Masters (LIVE)
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-1748">
                      Get YOUR specific questions answered. About YOUR
                      protocols. YOUR results. YOUR situation.
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* COSMIC TEXT SECTION - INSIDE OFFER BOX */}
            <div className="border-t-2 border-cyan-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-1749">
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 6.05
            }} className="mb-8 sm:mb-10 max-w-5xl mx-auto relative" data-id="element-1750">
                {/* Dramatic spotlight behind text */}
                <div className="absolute inset-0 -inset-x-32 bg-gradient-radial from-cyan-600/10 via-transparent to-transparent blur-3xl" data-id="element-1751" />

                {/* Cosmic background - NO BOX, just floating elements */}
                <div className="relative py-8 sm:py-12 px-4 sm:px-6 overflow-visible" data-id="element-1752">
                  {/* Animated Stars - floating freely */}
                  <div className="absolute inset-0 -inset-x-20 -inset-y-20 overflow-visible pointer-events-none" data-id="element-1753">
                    {[...Array(40)].map((_, i) => <motion.div key={i} className="absolute bg-cyan-300 rounded-full" style={{
                    width: Math.random() * 3 + 1 + 'px',
                    height: Math.random() * 3 + 1 + 'px',
                    top: Math.random() * 120 - 10 + '%',
                    left: Math.random() * 120 - 10 + '%',
                    boxShadow: '0 0 4px rgba(103, 232, 249, 0.6)'
                  }} animate={{
                    opacity: [0.2, 0.7, 0.2],
                    scale: [0.8, 1.3, 0.8]
                  }} transition={{
                    duration: Math.random() * 3 + 2,
                    repeat: Infinity,
                    ease: 'easeInOut',
                    delay: Math.random() * 2
                  }} data-id="element-1754" />)}
                  </div>

                  {/* Constellation Lines - subtle connections */}
                  <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-20 overflow-visible" data-id="element-1755">
                    <motion.path d="M100,30 L250,90 L400,50 L600,100" stroke="#22d3ee" strokeWidth="1" fill="none" initial={{
                    pathLength: 0,
                    opacity: 0
                  }} animate={{
                    pathLength: 1,
                    opacity: 0.3
                  }} transition={{
                    duration: 5,
                    ease: 'easeOut',
                    delay: 1
                  }} data-id="element-1756" />
                    <motion.path d="M50,100 L200,40 L350,110 L550,60" stroke="#67e8f9" strokeWidth="1" fill="none" initial={{
                    pathLength: 0,
                    opacity: 0
                  }} animate={{
                    pathLength: 1,
                    opacity: 0.25
                  }} transition={{
                    duration: 6,
                    ease: 'easeOut',
                    delay: 2
                  }} data-id="element-1757" />
                  </svg>

                  {/* The Cosmic Text - NO BOX, bold font, floating in space */}
                  <div className="relative z-10 text-center space-y-4 sm:space-y-6" data-id="element-1758">
                    <motion.p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-relaxed" initial={{
                    opacity: 0
                  }} animate={{
                    opacity: 1
                  }} transition={{
                    duration: 2,
                    delay: 0.5
                  }} data-id="element-1759">
                      <span className="block text-cyan-200 font-extrabold" style={{
                      textShadow: '0 0 15px rgba(103, 232, 249, 0.5), 0 0 30px rgba(103, 232, 249, 0.3)'
                    }} data-id="element-1760">
                        Gain access to whole new worlds,
                      </span>
                      <span className="block mt-4 text-cyan-100 font-extrabold" style={{
                      textShadow: '0 0 18px rgba(34, 211, 238, 0.6), 0 0 35px rgba(34, 211, 238, 0.4)'
                    }} data-id="element-1761">
                        different dimensions of thinking,
                      </span>
                      <span className="block mt-4 text-white font-extrabold" style={{
                      textShadow: '0 0 20px rgba(255, 255, 255, 0.5), 0 0 40px rgba(103, 232, 249, 0.4)'
                    }} data-id="element-1762">
                        and new paradigms for medicine,
                      </span>
                      <span className="block mt-4 text-cyan-200 font-extrabold" style={{
                      textShadow: '0 0 15px rgba(103, 232, 249, 0.5), 0 0 30px rgba(103, 232, 249, 0.3)'
                    }} data-id="element-1763">
                        biology and peptides
                      </span>
                    </motion.p>
                  </div>

                  {/* Shooting Stars - multiple for more cosmic feel */}
                  <motion.div className="absolute top-10 left-0 h-px w-32 bg-gradient-to-r from-transparent via-cyan-300 to-transparent" style={{
                  rotate: '25deg',
                  filter: 'drop-shadow(0 0 8px #22d3ee)'
                }} animate={{
                  x: ['-100%', '400%'],
                  y: ['-100%', '400%'],
                  opacity: [0, 1, 0]
                }} transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  repeatDelay: 8,
                  ease: 'easeOut'
                }} data-id="element-1764" />
                  <motion.div className="absolute bottom-20 right-0 h-px w-24 bg-gradient-to-r from-transparent via-cyan-400 to-transparent" style={{
                  rotate: '-30deg',
                  filter: 'drop-shadow(0 0 6px #67e8f9)'
                }} animate={{
                  x: ['100%', '-400%'],
                  y: ['100%', '-400%'],
                  opacity: [0, 1, 0]
                }} transition={{
                  duration: 3,
                  repeat: Infinity,
                  repeatDelay: 12,
                  ease: 'easeOut',
                  delay: 4
                }} data-id="element-1765" />
                </div>
              </motion.div>
            </div>

            {/* BUT MAKE SURE YOU UNDERSTAND Section - MOVED HERE */}

            {/* OR IF YOU'RE READY Section */}
            <div className="border-t-2 border-green-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-1766">
              {/* Elizabeth M. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 6.25
            }} className="relative mb-16" data-id="element-1767">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1768" />

                <div className="relative px-8 py-10" data-id="element-1769">
                  {/* Profile Image */}
                  <div className="flex justify-center mb-6" data-id="element-1770">
                    <div className="relative" data-id="element-1771">
                      <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1772" />
                      <img src="https://cdn.magicpatterns.com/uploads/7z7kG6cfruhkmzvLk7oX76/image09.jpg" alt="Elizabeth M." className="relative w-24 h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1773" />
                    </div>
                  </div>

                  {/* Large opening quote - purple */}
                  <div className="mb-6" data-id="element-1774">
                    <span className="text-purple-500/40 text-7xl font-serif leading-none" data-id="element-1775">
                      "
                    </span>
                  </div>

                  {/* TV Screen Frame around testimonial text */}
                  <div className="relative mb-8 max-w-3xl mx-auto" data-id="element-1776">
                    {/* Outer purple glow */}
                    <div className="absolute -inset-4 bg-purple-500/10 blur-xl rounded-lg" data-id="element-1777" />

                    {/* TV screen frame */}
                    <div className="relative border-2 border-purple-500/30 rounded-lg p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1778">
                      {/* Screen scanline effect (subtle) */}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1779" />

                      {/* Testimonial text - with emphasis on key phrases */}
                      <p className="text-stone-300 text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1780">
                        I've seen Brenden dissect complex pharmacological
                        mechanisms and explain them in a way that makes sense to
                        both medical professionals and laypeople alike.
                        <br data-id="element-1781" />
                        <br data-id="element-1782" />
                        He's able to{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1783">
                          predict outcomes and potential applications that
                          others simply don't see.
                        </span>
                        <br data-id="element-1784" />
                        <br data-id="element-1785" />
                        He's not afraid to challenge conventional wisdom when
                        the science doesn't support it. In a field often clouded
                        by hype and misinformation,{' '}
                        <span className="text-white font-bold" data-id="element-1786">
                          Brenden's dedication to truth is refreshing and
                          invaluable.
                        </span>
                        <br data-id="element-1787" />
                        <br data-id="element-1788" />
                        As the director of ReadyMed, I've worked with countless
                        physicians, hormone specialists, and pharmacists over
                        the years. But I can say without hesitation that{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1789">
                          Brenden Henry's knowledge of peptides, pharmacology,
                          and human biology is truly in a league of its own.
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* Attribution with client type */}
                  <div className="flex items-center gap-4" data-id="element-1790">
                    <div className="h-px flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1791" />
                    <div className="text-right" data-id="element-1792">
                      <p className="text-purple-400 font-semibold text-lg mb-1" data-id="element-1793">
                        Elizabeth M.
                      </p>
                      <p className="text-stone-500 text-sm" data-id="element-1794">
                        Director at ReadyMed, Peptide Mastery buyer
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Michelle M.N. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 6.9
            }} className="relative mt-16" data-id="element-1795">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1796" />
              </motion.div>
            </div>

            {/* SOPHISTICATED PRICING SECTION WITH STRONG ANCHORS */}
            <div className="border-t-2 border-amber-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-1797">
              {/* AMPLIFIED FOUNDING MEMBER MESSAGING */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.8,
              delay: 6.5
            }} className="text-center mb-12 relative" data-id="element-1798">
                {/* Dramatic glow effect */}
                <div className="absolute inset-0 bg-gradient-radial from-amber-600/20 via-transparent to-transparent blur-3xl" data-id="element-1799" />

                <div className="relative space-y-4 sm:space-y-6" data-id="element-1800">
                  {/* Main headline with intense emphasis */}
                  <motion.div animate={{
                  textShadow: ['0 0 40px rgba(251, 191, 36, 0.6)', '0 0 60px rgba(251, 191, 36, 0.9)', '0 0 40px rgba(251, 191, 36, 0.6)']
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-1801">
                    <h3 className="text-2xl sm:text-4xl md:text-5xl font-bold text-amber-400 mb-3 sm:mb-4" data-id="element-1802">
                      🔥 FOUNDING MEMBER EXCLUSIVE 🔥
                    </h3>
                  </motion.div>

                  <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4" data-id="element-1803">
                    <p className="text-xl sm:text-2xl md:text-3xl font-bold text-stone-100 leading-tight" data-id="element-1804">
                      This Is The{' '}
                      <span className="text-amber-400" data-id="element-1805">Most INSANE Offer</span>{' '}
                      We Will EVER Make
                    </p>

                    <p className="text-lg sm:text-xl text-stone-300 leading-relaxed" data-id="element-1806">
                      We're opening the doors to our{' '}
                      <span className="font-bold text-stone-100" data-id="element-1807">
                        Private Research Order
                      </span>{' '}
                      for the first time ever — and looking for the{' '}
                      <span className="font-bold text-stone-100" data-id="element-1808">
                        absolute best people
                      </span>{' '}
                      to join as Founding Members.
                    </p>

                    <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-1809">
                      Lock in your{' '}
                      <span className="text-green-400" data-id="element-1810">
                        grandfathered Founding Member rate
                      </span>{' '}
                      now — and keep it for life.
                    </p>

                    <p className="text-base sm:text-lg text-stone-400 italic" data-id="element-1811">
                      (As long as you remain a member, your rate never
                      increases)
                    </p>
                  </div>

                  {/* Celebratory Trophy Animation */}
                  <motion.div initial={{
                  opacity: 0,
                  scale: 0.8
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} transition={{
                  duration: 0.6,
                  delay: 6.55
                }} className="my-8 flex justify-center" data-id="element-1812">
                    <div className="relative w-48 h-32 md:w-64 md:h-40" data-id="element-1813">
                      {/* Trophy/Award Icon */}
                      <motion.svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 md:w-24 md:h-24" viewBox="0 0 24 24" fill="none" animate={{
                      y: [0, -8, 0],
                      rotate: [0, 5, 0, -5, 0]
                    }} transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: 'easeInOut'
                    }} data-id="element-1814">
                        {/* Trophy base */}
                        <path d="M12 15C15.866 15 19 11.866 19 8V5H5V8C5 11.866 8.13401 15 12 15Z" fill="url(#trophy-gradient)" stroke="#f59e0b" strokeWidth="1.5" data-id="element-1815" />
                        {/* Trophy stem */}
                        <path d="M12 15V19M9 19H15M9 22H15" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" data-id="element-1816" />
                        {/* Trophy handles */}
                        <path d="M5 8H3C2.44772 8 2 7.55228 2 7V6C2 5.44772 2.44772 5 3 5H5" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" data-id="element-1817" />
                        <path d="M19 8H21C21.5523 8 22 7.55228 22 7V6C22 5.44772 21.5523 5 21 5H19" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" data-id="element-1818" />
                        <defs data-id="element-1819">
                          <linearGradient id="trophy-gradient" x1="12" y1="5" x2="12" y2="15" data-id="element-1820">
                            <stop offset="0%" stopColor="#fbbf24" data-id="element-1821" />
                            <stop offset="100%" stopColor="#f59e0b" data-id="element-1822" />
                          </linearGradient>
                        </defs>
                      </motion.svg>

                      {/* Animated Confetti Particles */}
                      {[...Array(12)].map((_, i) => <motion.div key={i} className="absolute" style={{
                      left: '50%',
                      top: '50%',
                      width: i % 3 === 0 ? '8px' : '6px',
                      height: i % 3 === 0 ? '8px' : '6px'
                    }} animate={{
                      x: [0, Math.cos(i * Math.PI * 2 / 12) * 80],
                      y: [0, Math.sin(i * Math.PI * 2 / 12) * 60],
                      rotate: [0, 360],
                      opacity: [1, 0]
                    }} transition={{
                      duration: 2,
                      repeat: Infinity,
                      delay: i * 0.1,
                      ease: 'easeOut'
                    }} data-id="element-1823">
                          <div className={`w-full h-full rounded-full ${i % 4 === 0 ? 'bg-amber-400' : i % 4 === 1 ? 'bg-yellow-300' : i % 4 === 2 ? 'bg-amber-500' : 'bg-orange-400'}`} style={{
                        boxShadow: '0 0 8px currentColor'
                      }} data-id="element-1824" />
                        </motion.div>)}

                      {/* Sparkle Effects */}
                      {[...Array(6)].map((_, i) => <motion.div key={`sparkle-${i}`} className="absolute" style={{
                      left: `${20 + i * 15}%`,
                      top: `${30 + i % 2 * 20}%`
                    }} animate={{
                      scale: [0, 1, 0],
                      rotate: [0, 180],
                      opacity: [0, 1, 0]
                    }} transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      delay: i * 0.3,
                      ease: 'easeInOut'
                    }} data-id="element-1825">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-amber-400" data-id="element-1826">
                            <path d="M8 0L9.5 6.5L16 8L9.5 9.5L8 16L6.5 9.5L0 8L6.5 6.5L8 0Z" fill="currentColor" data-id="element-1827" />
                          </svg>
                        </motion.div>)}
                    </div>
                  </motion.div>

                  {/* Divider with emphasis */}
                  <div className="flex items-center justify-center gap-4 my-8" data-id="element-1828">
                    <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-1829" />
                    <div className="w-4 h-4 bg-amber-500 rotate-45 animate-pulse" data-id="element-1830" />
                    <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-1831" />
                  </div>

                  {/* THE "INSANE" PART Section - MOVED HERE */}
                  <motion.div initial={{
                  opacity: 0,
                  scale: 0.95
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} transition={{
                  duration: 0.6,
                  delay: 5.9
                }} className="text-center mb-12" data-id="element-1832">
                    <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4" style={{
                    textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
                  }} data-id="element-1833">
                      🎁 THE "INSANE" PART
                    </h3>
                    <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto mb-8" data-id="element-1834" />

                    <div className="space-y-6 max-w-3xl mx-auto" data-id="element-1835">
                      <p className="text-lg font-bold text-stone-100 underline decoration-amber-400 decoration-2 underline-offset-4" data-id="element-1836">
                        If you are accepted into the Order we will grant you a
                        complete scholarship to Peptide Mastery 2.0.
                      </p>

                      <div className="p-6 bg-amber-950/30 border-2 border-amber-500/40 rounded-lg" data-id="element-1837">
                        <p className="text-lg text-stone-300 mb-2" data-id="element-1838">
                          This is the most comprehensive peptide education ever
                          created.
                        </p>
                        <p className="text-2xl font-bold text-amber-400" data-id="element-1839">
                          Normally, it's $2,500 (pay-in-full ONLY).
                        </p>
                        <p className="text-stone-400 mt-2" data-id="element-1840">
                          We don't offer payment plans.
                        </p>
                      </div>

                      <div className="space-y-3" data-id="element-1841">
                        <p className="text-2xl font-bold text-amber-300" data-id="element-1842">
                          But as a Founding Member?
                        </p>
                        <p className="text-3xl font-bold text-green-400" style={{
                        textShadow: '0 0 30px rgba(74, 222, 128, 0.5)'
                      }} data-id="element-1843">
                          You get it FREE.
                        </p>
                      </div>

                      <p className="text-lg text-stone-300" data-id="element-1844">
                        Plus you're locking in a grandfathered monthly rate that
                        we'll NEVER offer again.
                      </p>

                      <p className="text-stone-400 italic text-sm" data-id="element-1845">
                        (Once this 4-day window closes, the Founding Member tier
                        disappears forever.)
                      </p>
                    </div>
                  </motion.div>

                  <p className="text-2xl font-bold text-amber-400" data-id="element-1846">
                    Choose Your Founding Member Path Below:
                  </p>
                </div>
              </motion.div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1847">
                {/* Option 1: Pay in Full */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 6.6
              }} className="relative p-6 sm:p-8 bg-gradient-to-br from-amber-900/40 to-black border-3 border-amber-500 rounded-xl shadow-[0_0_40px_rgba(217,119,6,0.3)] hover:shadow-[0_0_60px_rgba(217,119,6,0.5)] transition-all" data-id="element-1848">
                  {/* Best Value Badge */}
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-1849">
                    <div className="px-4 sm:px-6 py-2 bg-gradient-to-r from-green-600 to-green-500 rounded-full text-white text-xs sm:text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-1850">
                      BEST VALUE
                    </div>
                  </div>

                  <div className="text-center mb-6 mt-4" data-id="element-1851">
                    <p className="text-amber-400 font-semibold text-base sm:text-lg mb-2" data-id="element-1852">
                      Option 1
                    </p>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-bold text-stone-100 mb-4 leading-tight" data-id="element-1853">
                      Peptide Mastery 2.0 + PSI PRO{' '}
                      <span className="underline" data-id="element-1854">Annual</span> Membership
                      (Founding Member)
                    </h4>

                    {/* STRONG PRICE ANCHOR */}
                    <div className="mb-6 p-4 bg-red-950/30 border border-red-500/30 rounded-lg" data-id="element-1855">
                      <p className="text-red-400 text-xs sm:text-sm font-semibold mb-1" data-id="element-1856">
                        Normal Value:
                      </p>
                      <div className="flex items-center justify-center gap-3" data-id="element-1857">
                        <span className="text-2xl sm:text-3xl font-bold text-red-400 line-through opacity-60" data-id="element-1858">
                          $5,500
                        </span>
                        <span className="text-xs sm:text-sm text-red-300" data-id="element-1859">
                          ($2,500 + $3,000)
                        </span>
                      </div>
                    </div>

                    <div className="mb-4" data-id="element-1860">
                      <p className="text-green-400 text-xs sm:text-sm font-bold mb-2" data-id="element-1861">
                        Your Founding Member Price:
                      </p>
                      <div className="flex items-baseline justify-center gap-2" data-id="element-1862">
                        <span className="text-4xl sm:text-5xl font-bold text-amber-400" data-id="element-1863">
                          $2,200
                        </span>
                      </div>
                      <p className="text-green-400 font-bold text-base sm:text-lg mt-2" data-id="element-1864">
                        Save $3,300!
                      </p>
                      <p className="text-stone-400 text-xs sm:text-sm mt-1" data-id="element-1865">
                        Annual payment
                      </p>
                    </div>
                  </div>

                  <ul className="space-y-3 mb-8" data-id="element-1866">
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1867">
                      <svg className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1868">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1869" />
                      </svg>
                      <span data-id="element-1870">
                        Full Peptide Mastery 2.0{' '}
                        <span className="font-semibold text-amber-300" data-id="element-1871">
                          unlocked immediately
                        </span>{' '}
                        <span className="text-stone-400" data-id="element-1872">($2,500 value)</span>
                      </span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1873">
                      <svg className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1874">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1875" />
                      </svg>
                      <span data-id="element-1876">
                        12 months of PSI PRO membership{' '}
                        <span className="text-stone-400" data-id="element-1877">($3,000 value)</span>
                      </span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1878">
                      <svg className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1879">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1880" />
                      </svg>
                      <span data-id="element-1881">All live sessions, bonuses, case studies</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1882">
                      <svg className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1883">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1884" />
                      </svg>
                      <span data-id="element-1885">
                        <span className="font-semibold text-green-400" data-id="element-1886">
                          60% OFF
                        </span>{' '}
                        the normal price
                      </span>
                    </li>
                  </ul>

                  <a href="https://go.peptidescienceinstitute.com/pm-pro-annual-fm" className="block w-full px-4 sm:px-6 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black text-center font-bold text-base md:text-lg rounded-lg transition-all duration-300 shadow-[0_0_30px_rgba(217,119,6,0.4)] hover:shadow-[0_0_50px_rgba(217,119,6,0.6)] hover:scale-105 min-h-[44px]" data-id="element-1887">
                    Claim Founding Member Status — Pay in Full
                  </a>
                </motion.div>

                {/* Option 2: Monthly Payments */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 6.7
              }} className="relative p-6 sm:p-8 bg-gradient-to-br from-stone-900/60 to-black border-2 border-amber-500/60 rounded-xl shadow-[0_0_30px_rgba(217,119,6,0.2)] hover:shadow-[0_0_50px_rgba(217,119,6,0.4)] transition-all" data-id="element-1888">
                  <div className="text-center mb-6" data-id="element-1889">
                    <p className="text-amber-400 font-semibold text-base sm:text-lg mb-2" data-id="element-1890">
                      Option 2
                    </p>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-bold text-stone-100 mb-4 leading-tight" data-id="element-1891">
                      Peptide Mastery 2.0 + PSI PRO{' '}
                      <span className="underline" data-id="element-1892">Monthly</span> Membership
                      (Founding Member)
                    </h4>

                    {/* STRONG PRICE ANCHOR - UPDATED TO MATCH PAY IN FULL */}
                    <div className="mb-6 p-4 bg-red-950/30 border border-red-500/30 rounded-lg" data-id="element-1893">
                      <p className="text-red-400 text-xs sm:text-sm font-semibold mb-1" data-id="element-1894">
                        Normal Value:
                      </p>
                      <div className="flex items-center justify-center gap-3" data-id="element-1895">
                        <span className="text-2xl sm:text-3xl font-bold text-red-400 line-through opacity-60" data-id="element-1896">
                          $5,500
                        </span>
                        <span className="text-xs sm:text-sm text-red-300" data-id="element-1897">
                          ($2,500 + $3,000)
                        </span>
                      </div>
                      <p className="text-xs text-red-300 mt-1" data-id="element-1898">
                        ($5,500 ÷ 12 months = $458/mo)
                      </p>
                    </div>

                    <div className="mb-4" data-id="element-1899">
                      <p className="text-green-400 text-xs sm:text-sm font-bold mb-2" data-id="element-1900">
                        Your Founding Member Price:
                      </p>
                      <div className="flex items-baseline justify-center gap-2" data-id="element-1901">
                        <span className="text-4xl sm:text-5xl font-bold text-amber-400" data-id="element-1902">
                          $220
                        </span>
                        <span className="text-2xl text-stone-400" data-id="element-1903">/mo</span>
                      </div>
                      <p className="text-green-400 font-bold text-base mt-2" data-id="element-1904">
                        Save $2,860!
                      </p>
                      <p className="text-stone-400 text-xs sm:text-sm mt-2" data-id="element-1905">
                        <span className="bg-amber-500/20 text-amber-300 px-2 py-1 rounded font-semibold" data-id="element-1906">
                          12-month commitment
                        </span>{' '}
                        • Total: $2,640
                      </p>
                    </div>
                  </div>

                  <ul className="space-y-3 mb-8" data-id="element-1907">
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1908">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1909">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1910" />
                      </svg>
                      <span data-id="element-1911">
                        Peptide Mastery 2.0{' '}
                        <span className="font-semibold text-amber-300" data-id="element-1912">
                          unlocked monthly
                        </span>{' '}
                        <span className="text-stone-400" data-id="element-1913">($2,500 value)</span>
                      </span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1914">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1915">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1916" />
                      </svg>
                      <span data-id="element-1917">
                        12 months of PSI PRO membership{' '}
                        <span className="text-stone-400" data-id="element-1918">($3,000 value)</span>
                      </span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1919">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1920">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1921" />
                      </svg>
                      <span data-id="element-1922">All live sessions, bonuses, case studies</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1923">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1924">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1925" />
                      </svg>
                      <span data-id="element-1926">
                        <span className="font-semibold text-green-400" data-id="element-1927">
                          52% OFF
                        </span>{' '}
                        the normal monthly rate
                      </span>
                    </li>
                  </ul>

                  <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" className="block w-full px-4 sm:px-6 py-4 sm:py-5 bg-gradient-to-r from-amber-600/80 to-amber-500/80 hover:from-amber-600 hover:to-amber-500 text-black text-center font-bold text-base md:text-lg rounded-lg transition-all duration-300 hover:scale-105 min-h-[44px]" data-id="element-1928">
                    Claim Founding Member Status — Monthly
                  </a>
                </motion.div>
              </div>

              {/* Option 3: Alumni */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 6.8
            }} className="p-6 sm:p-8 bg-gradient-to-r from-purple-950/40 to-black border-2 border-purple-600/50 rounded-lg text-center" data-id="element-1929">
                <p className="text-purple-300 font-bold text-lg sm:text-xl mb-2" data-id="element-1930">
                  Already Own Peptide Mastery?
                </p>
                <p className="text-purple-200 mb-4 text-sm sm:text-base" data-id="element-1931">
                  Get special alumni pricing on the membership
                </p>
                <a href="mailto:support@support.peptidescienceinstitute.com" className="inline-block px-6 sm:px-8 py-3 bg-purple-600 hover:bg-purple-500 text-white font-bold rounded-lg transition-all duration-300 min-h-[44px]" data-id="element-1932">
                  Contact Us for Alumni Pricing
                </a>
              </motion.div>

              {/* BUT MAKE SURE YOU UNDERSTAND Section - MOVED HERE */}

              {/* THE DEADLINE Section */}
              <div className="border-t-2 border-amber-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-1933">
                <motion.div initial={{
                opacity: 0,
                scale: 0.95
              }} animate={{
                opacity: 1,
                scale: 1
              }} transition={{
                duration: 0.6,
                delay: 6.85
              }} className="text-center mb-6 sm:mb-8" data-id="element-1934">
                  <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4" style={{
                  textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
                }} data-id="element-1935">
                    ⏰ THE DEADLINE
                  </h3>
                  <div className="w-24 sm:w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-1936" />
                </motion.div>

                <div className="space-y-4 sm:space-y-6 max-w-3xl mx-auto text-center" data-id="element-1937">
                  <div className="p-6 sm:p-8 bg-gradient-to-r from-red-950/40 via-amber-950/40 to-red-950/40 border-2 border-amber-500/50 rounded-lg" data-id="element-1938">
                    <p className="text-xl sm:text-2xl font-bold text-amber-300 mb-3 sm:mb-4" data-id="element-1939">
                      This opportunity is only open until Friday, January 30th
                      at 11:59pm ET
                    </p>
                    <p className="text-lg sm:text-xl text-stone-300 mb-2" data-id="element-1940">
                      After that, the doors close.
                    </p>
                    <p className="text-lg sm:text-xl text-stone-300 mb-2" data-id="element-1941">
                      The Founding Member status vanishes.
                    </p>
                    <p className="text-lg sm:text-xl font-bold text-red-400" data-id="element-1942">
                      And the price goes up.
                    </p>
                  </div>
                </div>
              </div>

              {/* Michelle M.N. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 6.9
            }} className="relative mt-8" data-id="element-1943">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1944" />

                <div className="relative px-8 py-10" data-id="element-1945">
                  {/* Profile Image */}
                  <div className="flex justify-center mb-6" data-id="element-1946">
                    <div className="relative" data-id="element-1947">
                      <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1948" />
                      <img src="https://cdn.magicpatterns.com/uploads/9qMkPazyxjG9vTCAeui9mc/MichelleMN.jpg" alt="Michelle M.N." className="relative w-24 h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1949" />
                    </div>
                  </div>

                  {/* Large opening quote - purple */}
                  <div className="mb-6" data-id="element-1950">
                    <span className="text-purple-500/40 text-7xl font-serif leading-none" data-id="element-1951">
                      "
                    </span>
                  </div>

                  {/* TV Screen Frame around testimonial text */}
                  <div className="relative mb-8 max-w-3xl mx-auto" data-id="element-1952">
                    {/* Outer purple glow */}
                    <div className="absolute -inset-4 bg-purple-500/10 blur-xl rounded-lg" data-id="element-1953" />

                    {/* TV screen frame */}
                    <div className="relative border-2 border-purple-500/30 rounded-lg p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1954">
                      {/* Screen scanline effect (subtle) */}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1955" />

                      {/* Testimonial text - with emphasis on key phrases */}
                      <p className="text-stone-300 text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1956">
                        I'm going through the peptide mastery and all the other
                        peptide courses and resources I've purchased from you
                        guys{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1957">
                          (I am LOVING it all!!)
                        </span>
                        ... I'm a functional medicine practitioner and{' '}
                        <span className="text-white font-bold" data-id="element-1958">
                          I can't wait to incorporate some of these protocols
                          with my patients!!!
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* Attribution with client type */}
                  <div className="flex items-center gap-4" data-id="element-1959">
                    <div className="h-px flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1960" />
                    <div className="text-right" data-id="element-1961">
                      <p className="text-purple-400 font-semibold text-lg mb-1" data-id="element-1962">
                        Michelle M.N.
                      </p>
                      <p className="text-stone-500 text-sm" data-id="element-1963">
                        Doctor of Chiropractic & Certified Functional Medicine
                        Practitioner, Peptide Mastery buyer
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Tony R. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 7.1
            }} className="relative mt-16" data-id="element-1964">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1965" />

                <div className="relative px-8 py-10" data-id="element-1966">
                  {/* Profile Image */}
                  <div className="flex justify-center mb-6" data-id="element-1967">
                    <div className="relative" data-id="element-1968">
                      <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1969" />
                      <img src="https://cdn.magicpatterns.com/uploads/p7h6Y7wV2aZ8GFLXspCfFF/TonyR.jpg" alt="Tony R." className="relative w-24 h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1970" />
                    </div>
                  </div>

                  {/* Large opening quote - purple */}
                  <div className="mb-6" data-id="element-1971">
                    <span className="text-purple-500/40 text-7xl font-serif leading-none" data-id="element-1972">
                      "
                    </span>
                  </div>

                  {/* TV Screen Frame around testimonial text */}
                  <div className="relative mb-8 max-w-3xl mx-auto" data-id="element-1973">
                    {/* Outer purple glow */}
                    <div className="absolute -inset-4 bg-purple-500/10 blur-xl rounded-lg" data-id="element-1974" />

                    {/* TV screen frame */}
                    <div className="relative border-2 border-purple-500/30 rounded-lg p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1975">
                      {/* Screen scanline effect (subtle) */}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1976" />

                      {/* Testimonial text - with emphasis on key phrases */}
                      <p className="text-stone-300 text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1977">
                        I was honestly frustrated at first. All the questions,
                        testing and monitoring seemed excessive. But I
                        understand why it was so important. Everything gave you
                        information to fine-tune my program... What you have
                        managed to do is{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1978">
                          absolutely bonkers.
                        </span>{' '}
                        This is like a{' '}
                        <span className="text-white font-bold" data-id="element-1979">
                          whole different planet of health optimization that
                          most people don't even know exists
                        </span>
                        ... I've gone from{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1980">
                          thinking about my funeral to planning hiking trips.
                        </span>{' '}
                        I can't thank you guys and the team enough.
                      </p>
                    </div>
                  </div>

                  {/* Attribution with client type */}
                  <div className="flex items-center gap-4" data-id="element-1981">
                    <div className="h-px flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1982" />
                    <div className="text-right" data-id="element-1983">
                      <p className="text-purple-400 font-semibold text-lg mb-1" data-id="element-1984">
                        Tony R.
                      </p>
                      <p className="text-stone-500 text-sm" data-id="element-1985">
                        Transformation Services Client
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* TRANSITION SECTION - "WANT THE FULL DETAILS?" */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 6.9
      }} className="mt-12 sm:mt-20 mb-10 sm:mb-16 text-center max-w-3xl mx-auto" data-id="element-1986">
          {/* Scroll icon */}
          <motion.div className="flex justify-center mb-6" animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1987">
            <div className="w-12 h-12 rounded-full bg-amber-500/20 border-2 border-amber-500/40 flex items-center justify-center" data-id="element-1988">
              <svg className="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1989">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 13l-7 7-7-7m14-8l-7 7-7-7" data-id="element-1990" />
              </svg>
            </div>
          </motion.div>

          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4 sm:mb-6" style={{
          textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
        }} data-id="element-1991">
            📜 WANT THE FULL DETAILS?
          </h3>

          <div className="space-y-3 sm:space-y-4 text-stone-300" data-id="element-1992">
            <p className="text-lg sm:text-xl font-semibold" data-id="element-1993">
              Keep reading below.
            </p>

            <p className="text-base sm:text-lg" data-id="element-1994">
              I'm going to walk you through EXACTLY what you're getting...
            </p>

            <p className="text-base sm:text-lg" data-id="element-1995">
              Why this matters more now than ever...
            </p>

            <p className="text-base sm:text-lg font-bold text-amber-400" data-id="element-1996">
              And why this might be the most important decision you make all
              year.
            </p>
          </div>

          {/* Decorative divider */}
          <div className="flex items-center justify-center gap-4 mt-10" data-id="element-1997">
            <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-1998" />
            <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-1999" />
            <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-2000" />
          </div>
        </motion.div>

        {/* Enhanced scroll indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 5.0
      }} className="mt-16" data-id="element-2001">
          <div className="flex flex-col items-center gap-3" data-id="element-2002">
            <p className="text-amber-500 text-sm tracking-wider uppercase" data-id="element-2003">
              Discover More
            </p>
            <motion.div className="w-px h-16 bg-gradient-to-b from-amber-600 to-transparent" animate={{
            opacity: [0.3, 1, 0.3]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-2004" />
            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-2005">
              <ChevronDown className="w-6 h-6 text-amber-600" data-id="element-2006" />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}